/**
 * @generated SignedSource<<5b5e123af7dc4434604c46d50dd9c961>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useRentalDetailRelayQuery$variables = {
  id: string;
};
export type useRentalDetailRelayQuery$data = {
  readonly getRental: {
    readonly adminModification: number | null | undefined;
    readonly adminModificationReason: string | null | undefined;
    readonly canceledOn: any | null | undefined;
    readonly ccHold: {
      readonly amount: number | null | undefined;
      readonly created: any | null | undefined;
      readonly description: string | null | undefined;
      readonly id: string;
      readonly status: string | null | undefined;
    } | null | undefined;
    readonly charge: {
      readonly amount: number | null | undefined;
      readonly created: any | null | undefined;
      readonly description: string | null | undefined;
      readonly id: string;
      readonly status: string | null | undefined;
    } | null | undefined;
    readonly chargeAmount: number | null | undefined;
    readonly chargeId: string | null | undefined;
    readonly chargePending: boolean | null | undefined;
    readonly chargePendingDecisionDate: any | null | undefined;
    readonly chargePendingNote: string | null | undefined;
    readonly chargePendingStatus: boolean | null | undefined;
    readonly chargeSuccess: boolean | null | undefined;
    readonly chargeTotal: number | null | undefined;
    readonly completed: boolean | null | undefined;
    readonly coupon: {
      readonly active: boolean | null | undefined;
      readonly code: string | null | undefined;
      readonly created: any | null | undefined;
      readonly discount: number | null | undefined;
      readonly discountType: string | null | undefined;
      readonly duration: number | null | undefined;
      readonly id: string;
      readonly name: string;
      readonly oldId: string | null | undefined;
      readonly uses: number | null | undefined;
    } | null | undefined;
    readonly createdOn: any | null | undefined;
    readonly distance: number | null | undefined;
    readonly distanceFormatted: any | null | undefined;
    readonly duration: number | null | undefined;
    readonly effectiveGracePeriod: number | null | undefined;
    readonly endBy: any | null | undefined;
    readonly endImageUrl: string | null | undefined;
    readonly endLat: number | null | undefined;
    readonly endLng: number | null | undefined;
    readonly endLocation: {
      readonly id: string;
      readonly lat: number | null | undefined;
      readonly lng: number | null | undefined;
      readonly name: string;
      readonly oldId: string | null | undefined;
    } | null | undefined;
    readonly endTime: any | null | undefined;
    readonly endTriggeredBy: any | null | undefined;
    readonly endType: string | null | undefined;
    readonly endedWithinGracePeriod: boolean | null | undefined;
    readonly failedStart: boolean | null | undefined;
    readonly feeIds: ReadonlyArray<string> | null | undefined;
    readonly fees: ReadonlyArray<{
      readonly amount: number;
      readonly appliedPostTax: boolean;
      readonly id: string;
      readonly name: string;
    }> | null | undefined;
    readonly feesPostTaxAmount: number;
    readonly forceEndAck: boolean | null | undefined;
    readonly forceEndTime: any | null | undefined;
    readonly forceEndType: string | null | undefined;
    readonly gracePeriod: number | null | undefined;
    readonly hardware: {
      readonly children: ReadonlyArray<{
        readonly hardwareType: {
          readonly id: string;
          readonly name: string | null | undefined;
        } | null | undefined;
        readonly id: string;
        readonly label: string | null | undefined;
        readonly number: number | null | undefined;
        readonly oldId: string | null | undefined;
      }>;
      readonly hardwareProduct: {
        readonly hasLocationTracking: boolean | null | undefined;
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
      readonly hardwareType: {
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
      readonly id: string;
      readonly label: string | null | undefined;
      readonly number: number | null | undefined;
      readonly oldId: string | null | undefined;
    } | null | undefined;
    readonly hardwareOldId: string | null | undefined;
    readonly id: string;
    readonly images: ReadonlyArray<any> | null | undefined;
    readonly isVoidCharge: boolean;
    readonly oldId: string | null | undefined;
    readonly organizationId: string | null | undefined;
    readonly parkingCredit: number | null | undefined;
    readonly perk: {
      readonly discount: number | null | undefined;
      readonly durationMoneyOff: number | null | undefined;
      readonly freeTime: number | null | undefined;
      readonly id: string;
      readonly membership: {
        readonly name: string;
      } | null | undefined;
      readonly membershipOldId: string | null | undefined;
      readonly minutes: number | null | undefined;
      readonly moneyOff: number | null | undefined;
      readonly oldId: string | null | undefined;
      readonly unlocks: number | null | undefined;
      readonly waiveBaseRate: boolean | null | undefined;
    } | null | undefined;
    readonly rate: {
      readonly activeOn: any | null | undefined;
      readonly archivedOn: any | null | undefined;
      readonly baseRate: number | null | undefined;
      readonly baseRateIncludedTime: number | null | undefined;
      readonly creditCardHold: number | null | undefined;
      readonly freeTime: number | null | undefined;
      readonly hidden: boolean | null | undefined;
      readonly id: string;
      readonly maxPeriods: number | null | undefined;
      readonly maxRentals: number | null | undefined;
      readonly membershipRequired: boolean;
      readonly minimumWalletDeposit: number | null | undefined;
      readonly name: string;
      readonly oldId: string | null | undefined;
      readonly periodDuration: number | null | undefined;
      readonly pricePerPeriod: number | null | undefined;
    } | null | undefined;
    readonly rating: number | null | undefined;
    readonly refundAmount: number | null | undefined;
    readonly refundComment: string | null | undefined;
    readonly reviewStatus: string | null | undefined;
    readonly startLat: number | null | undefined;
    readonly startLng: number | null | undefined;
    readonly startLocation: {
      readonly id: string;
      readonly lat: number | null | undefined;
      readonly lng: number | null | undefined;
      readonly name: string;
      readonly oldId: string | null | undefined;
    } | null | undefined;
    readonly startTime: any | null | undefined;
    readonly startTriggeredBy: any | null | undefined;
    readonly startType: string | null | undefined;
    readonly supportMessages: ReadonlyArray<{
      readonly content: string | null | undefined;
      readonly created: any | null | undefined;
      readonly id: string;
      readonly notes: string | null | undefined;
      readonly oldId: string | null | undefined;
      readonly owner: string | null | undefined;
      readonly state: number | null | undefined;
      readonly subtype: string | null | undefined;
      readonly tags: ReadonlyArray<string> | null | undefined;
      readonly type: number | null | undefined;
    }>;
    readonly system: {
      readonly billingLive: boolean | null | undefined;
      readonly countryCode: string | null | undefined;
      readonly id: string;
      readonly name: string | null | undefined;
      readonly newHardware: boolean | null | undefined;
      readonly oldId: string | null | undefined;
      readonly roundTrip: boolean | null | undefined;
    } | null | undefined;
    readonly systemId: string | null | undefined;
    readonly systemOldId: string | null | undefined;
    readonly taxAmount: any | null | undefined;
    readonly taxRate: any | null | undefined;
    readonly tripDistance: number | null | undefined;
    readonly usageSubtotal: number | null | undefined;
    readonly user: {
      readonly firstName: string;
      readonly fullName: string | null | undefined;
      readonly id: string;
      readonly lastName: string;
      readonly phone: string;
    } | null | undefined;
    readonly userId: string | null | undefined;
    readonly userOldId: string | null | undefined;
    readonly voidBy: string | null | undefined;
    readonly voidByAdmin: {
      readonly email: string;
      readonly firstName: string;
      readonly id: string;
      readonly lastName: string;
    } | null | undefined;
    readonly voidReason: string | null | undefined;
    readonly voidedOn: any | null | undefined;
    readonly walletTransaction: {
      readonly amount: number | null | undefined;
      readonly createdOn: any;
      readonly description: string | null | undefined;
      readonly id: string;
      readonly oldId: string | null | undefined;
      readonly type: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useRentalDetailRelayQuery = {
  response: useRentalDetailRelayQuery$data;
  variables: useRentalDetailRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oldId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "organizationId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdOn",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phone",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    },
    (v6/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userOldId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "HardwareType",
  "kind": "LinkedField",
  "name": "hardwareType",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v13/*: any*/)
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "Hardware",
  "kind": "LinkedField",
  "name": "hardware",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    (v11/*: any*/),
    (v12/*: any*/),
    (v14/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "HardwareProduct",
      "kind": "LinkedField",
      "name": "hardwareProduct",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v13/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasLocationTracking",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Hardware",
      "kind": "LinkedField",
      "name": "children",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        (v3/*: any*/),
        (v11/*: any*/),
        (v12/*: any*/),
        (v14/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hardwareOldId",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "System",
  "kind": "LinkedField",
  "name": "system",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    (v13/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "countryCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "billingLive",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "roundTrip",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "newHardware",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "systemId",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "systemOldId",
  "storageKey": null
},
v20 = [
  (v2/*: any*/),
  (v3/*: any*/),
  (v13/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lat",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lng",
    "storageKey": null
  }
],
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "Location",
  "kind": "LinkedField",
  "name": "startLocation",
  "plural": false,
  "selections": (v20/*: any*/),
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "Location",
  "kind": "LinkedField",
  "name": "endLocation",
  "plural": false,
  "selections": (v20/*: any*/),
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startLat",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startLng",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endLat",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endLng",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startTime",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endTime",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "duration",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endBy",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gracePeriod",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "effectiveGracePeriod",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endedWithinGracePeriod",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "distance",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "distanceFormatted",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tripDistance",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "chargeAmount",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "chargeTotal",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "chargeId",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "chargeSuccess",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
},
v44 = [
  (v2/*: any*/),
  (v41/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  },
  (v42/*: any*/),
  (v43/*: any*/)
],
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "Charge",
  "kind": "LinkedField",
  "name": "charge",
  "plural": false,
  "selections": (v44/*: any*/),
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "concreteType": "Charge",
  "kind": "LinkedField",
  "name": "ccHold",
  "plural": false,
  "selections": (v44/*: any*/),
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taxAmount",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taxRate",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "usageSubtotal",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "adminModification",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "adminModificationReason",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parkingCredit",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "concreteType": "Fee",
  "kind": "LinkedField",
  "name": "fees",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v13/*: any*/),
    (v41/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appliedPostTax",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "feeIds",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "feesPostTaxAmount",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "refundAmount",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "refundComment",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "concreteType": "WalletTransaction",
  "kind": "LinkedField",
  "name": "walletTransaction",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    (v41/*: any*/),
    (v42/*: any*/),
    (v58/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "chargePending",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "chargePendingDecisionDate",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "chargePendingNote",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "chargePendingStatus",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isVoidCharge",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "voidReason",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "voidedOn",
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "voidBy",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "concreteType": "AdminUser",
  "kind": "LinkedField",
  "name": "voidByAdmin",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    (v6/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "forceEndType",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "forceEndTime",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "forceEndAck",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startTriggeredBy",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endTriggeredBy",
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startType",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endType",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "images",
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endImageUrl",
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "discount",
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "concreteType": "Coupon",
  "kind": "LinkedField",
  "name": "coupon",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    (v13/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "discountType",
      "storageKey": null
    },
    (v78/*: any*/),
    (v29/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uses",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "active",
      "storageKey": null
    },
    (v43/*: any*/)
  ],
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "freeTime",
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "concreteType": "Rate",
  "kind": "LinkedField",
  "name": "rate",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    (v13/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "baseRate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "baseRateIncludedTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pricePerPeriod",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "periodDuration",
      "storageKey": null
    },
    (v80/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "creditCardHold",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minimumWalletDeposit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hidden",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "membershipRequired",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxPeriods",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxRentals",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "activeOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "archivedOn",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "membershipOldId",
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minutes",
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "moneyOff",
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "durationMoneyOff",
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "waiveBaseRate",
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unlocks",
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "concreteType": "SupportTicket",
  "kind": "LinkedField",
  "name": "supportMessages",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "content",
      "storageKey": null
    },
    (v43/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "owner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    (v58/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subtype",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tags",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v89 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completed",
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rating",
  "storageKey": null
},
v91 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "failedStart",
  "storageKey": null
},
v92 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canceledOn",
  "storageKey": null
},
v93 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reviewStatus",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useRentalDetailRelayQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Rental",
        "kind": "LinkedField",
        "name": "getRental",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          (v26/*: any*/),
          (v27/*: any*/),
          (v28/*: any*/),
          (v29/*: any*/),
          (v30/*: any*/),
          (v31/*: any*/),
          (v32/*: any*/),
          (v33/*: any*/),
          (v34/*: any*/),
          (v35/*: any*/),
          (v36/*: any*/),
          (v37/*: any*/),
          (v38/*: any*/),
          (v39/*: any*/),
          (v40/*: any*/),
          (v45/*: any*/),
          (v46/*: any*/),
          (v47/*: any*/),
          (v48/*: any*/),
          (v49/*: any*/),
          (v50/*: any*/),
          (v51/*: any*/),
          (v52/*: any*/),
          (v53/*: any*/),
          (v54/*: any*/),
          (v55/*: any*/),
          (v56/*: any*/),
          (v57/*: any*/),
          (v59/*: any*/),
          (v60/*: any*/),
          (v61/*: any*/),
          (v62/*: any*/),
          (v63/*: any*/),
          (v64/*: any*/),
          (v65/*: any*/),
          (v66/*: any*/),
          (v67/*: any*/),
          (v68/*: any*/),
          (v69/*: any*/),
          (v70/*: any*/),
          (v71/*: any*/),
          (v72/*: any*/),
          (v73/*: any*/),
          (v74/*: any*/),
          (v75/*: any*/),
          (v76/*: any*/),
          (v77/*: any*/),
          (v79/*: any*/),
          (v81/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Perk",
            "kind": "LinkedField",
            "name": "perk",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v82/*: any*/),
              (v80/*: any*/),
              (v83/*: any*/),
              (v84/*: any*/),
              (v85/*: any*/),
              (v78/*: any*/),
              (v86/*: any*/),
              (v87/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Membership",
                "kind": "LinkedField",
                "name": "membership",
                "plural": false,
                "selections": [
                  (v13/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v88/*: any*/),
          (v89/*: any*/),
          (v90/*: any*/),
          (v91/*: any*/),
          (v92/*: any*/),
          (v93/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useRentalDetailRelayQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Rental",
        "kind": "LinkedField",
        "name": "getRental",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          (v26/*: any*/),
          (v27/*: any*/),
          (v28/*: any*/),
          (v29/*: any*/),
          (v30/*: any*/),
          (v31/*: any*/),
          (v32/*: any*/),
          (v33/*: any*/),
          (v34/*: any*/),
          (v35/*: any*/),
          (v36/*: any*/),
          (v37/*: any*/),
          (v38/*: any*/),
          (v39/*: any*/),
          (v40/*: any*/),
          (v45/*: any*/),
          (v46/*: any*/),
          (v47/*: any*/),
          (v48/*: any*/),
          (v49/*: any*/),
          (v50/*: any*/),
          (v51/*: any*/),
          (v52/*: any*/),
          (v53/*: any*/),
          (v54/*: any*/),
          (v55/*: any*/),
          (v56/*: any*/),
          (v57/*: any*/),
          (v59/*: any*/),
          (v60/*: any*/),
          (v61/*: any*/),
          (v62/*: any*/),
          (v63/*: any*/),
          (v64/*: any*/),
          (v65/*: any*/),
          (v66/*: any*/),
          (v67/*: any*/),
          (v68/*: any*/),
          (v69/*: any*/),
          (v70/*: any*/),
          (v71/*: any*/),
          (v72/*: any*/),
          (v73/*: any*/),
          (v74/*: any*/),
          (v75/*: any*/),
          (v76/*: any*/),
          (v77/*: any*/),
          (v79/*: any*/),
          (v81/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Perk",
            "kind": "LinkedField",
            "name": "perk",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v82/*: any*/),
              (v80/*: any*/),
              (v83/*: any*/),
              (v84/*: any*/),
              (v85/*: any*/),
              (v78/*: any*/),
              (v86/*: any*/),
              (v87/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Membership",
                "kind": "LinkedField",
                "name": "membership",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v88/*: any*/),
          (v89/*: any*/),
          (v90/*: any*/),
          (v91/*: any*/),
          (v92/*: any*/),
          (v93/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2820b5e03b4b5e29ba905dca0941eb96",
    "id": null,
    "metadata": {},
    "name": "useRentalDetailRelayQuery",
    "operationKind": "query",
    "text": "query useRentalDetailRelayQuery(\n  $id: ID!\n) {\n  getRental(id: $id) {\n    id\n    oldId\n    organizationId\n    createdOn\n    user {\n      id\n      phone\n      fullName\n      firstName\n      lastName\n    }\n    userId\n    userOldId\n    hardware {\n      id\n      oldId\n      number\n      label\n      hardwareType {\n        id\n        name\n      }\n      hardwareProduct {\n        id\n        name\n        hasLocationTracking\n      }\n      children {\n        id\n        oldId\n        number\n        label\n        hardwareType {\n          id\n          name\n        }\n      }\n    }\n    hardwareOldId\n    system {\n      id\n      oldId\n      name\n      countryCode\n      billingLive\n      roundTrip\n      newHardware\n    }\n    systemId\n    systemOldId\n    startLocation {\n      id\n      oldId\n      name\n      lat\n      lng\n    }\n    endLocation {\n      id\n      oldId\n      name\n      lat\n      lng\n    }\n    startLat\n    startLng\n    endLat\n    endLng\n    startTime\n    endTime\n    duration\n    endBy\n    gracePeriod\n    effectiveGracePeriod\n    endedWithinGracePeriod\n    distance\n    distanceFormatted\n    tripDistance\n    chargeAmount\n    chargeTotal\n    chargeId\n    chargeSuccess\n    charge {\n      id\n      amount\n      status\n      description\n      created\n    }\n    ccHold {\n      id\n      amount\n      status\n      description\n      created\n    }\n    taxAmount\n    taxRate\n    usageSubtotal\n    adminModification\n    adminModificationReason\n    parkingCredit\n    fees {\n      id\n      name\n      amount\n      appliedPostTax\n    }\n    feeIds\n    feesPostTaxAmount\n    refundAmount\n    refundComment\n    walletTransaction {\n      id\n      oldId\n      amount\n      description\n      type\n      createdOn\n    }\n    chargePending\n    chargePendingDecisionDate\n    chargePendingNote\n    chargePendingStatus\n    isVoidCharge\n    voidReason\n    voidedOn\n    voidBy\n    voidByAdmin {\n      id\n      email\n      firstName\n      lastName\n    }\n    forceEndType\n    forceEndTime\n    forceEndAck\n    startTriggeredBy\n    endTriggeredBy\n    startType\n    endType\n    images\n    endImageUrl\n    coupon {\n      id\n      oldId\n      code\n      name\n      discountType\n      discount\n      duration\n      uses\n      active\n      created\n    }\n    rate {\n      id\n      oldId\n      name\n      baseRate\n      baseRateIncludedTime\n      pricePerPeriod\n      periodDuration\n      freeTime\n      creditCardHold\n      minimumWalletDeposit\n      hidden\n      membershipRequired\n      maxPeriods\n      maxRentals\n      activeOn\n      archivedOn\n    }\n    perk {\n      id\n      oldId\n      membershipOldId\n      freeTime\n      minutes\n      moneyOff\n      durationMoneyOff\n      discount\n      waiveBaseRate\n      unlocks\n      membership {\n        name\n        id\n      }\n    }\n    supportMessages {\n      id\n      oldId\n      content\n      created\n      owner\n      notes\n      state\n      type\n      subtype\n      tags\n    }\n    completed\n    rating\n    failedStart\n    canceledOn\n    reviewStatus\n  }\n}\n"
  }
};
})();

(node as any).hash = "300264e57d4727c8562562c23db9e638";

export default node;
